import React from 'react'
import { Link } from 'react-router-dom'

const CoachDetail = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Coach Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Coach Management detail</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/coach-management"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="profile_modal_wrap">
                        <div className="main-body">
                            <ul className="nav nav-tabs mb-3" id="mainTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="modal_details" data-bs-toggle="tab" data-bs-target="#modaldetails" type="button">Details</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="modal_matchhistory" data-bs-toggle="tab" data-bs-target="#modalmatchhistory" type="button">Match History</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="modaldetails" role="tabpanel">
                                    <div className="card personal_d">
                                        <div className="card-body">
                                            <h2>Personal Details</h2>
                                            <div className="row">
                                                <div className="col-lg-2">
                                                    <div className="d-flex flex-column align-items-center text-center">
                                                        <img src="images/avatars/avatar-1.png" alt="Admin" className="rounded-circle p-1 bg-primary" width={150} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-5">
                                                    <div className="inp_grp">
                                                        <label>Full Name</label>
                                                        <input type="text" className="form-control" defaultValue="John Clark" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Contact Number</label>
                                                        <input type="text" className="form-control" defaultValue="+0 000-0000-0000" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Email</label>
                                                        <input type="text" className="form-control" defaultValue="john_clark@gmail.com" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-5">
                                                    <div className="inp_grp">
                                                        <label>DOB</label>
                                                        <input type="text" className="form-control" defaultValue="1995-05-10" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Country</label>
                                                        <input type="text" className="form-control" defaultValue="USA" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Zip code</label>
                                                        <input type="text" className="form-control" defaultValue={445522} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card personal_d mt-4">
                                        <div className="card-body">
                                            <h2>Professional Details</h2>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <label>Experience Level</label>
                                                        <input type="text" className="form-control" defaultValue="Senior (10 Years)" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Preferred Age Group</label>
                                                        <input type="text" className="form-control" defaultValue={42} readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Teams Assigned</label>
                                                        <input type="text" className="form-control" defaultValue="Red Dragons" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <label>Teams Count</label>
                                                        <input type="text" className="form-control" defaultValue={55} readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Passport/National ID</label>
                                                        <input type="text" className="form-control" defaultValue="91-4527893" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Registration Number</label>
                                                        <input type="text" className="form-control" defaultValue="SC-2024-78541" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <label>Licence Number</label>
                                                        <input type="text" className="form-control" defaultValue="USSF License" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Certifications</label>
                                                        <input type="text" className="form-control" defaultValue="USSF License, UEFA B License" readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card personal_d mt-4">
                                        <div className="card-body">
                                            <h2>Documents</h2>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <i className="bx bxs-file" />
                                                            <div>
                                                                <h5>Coaching License</h5>
                                                                <p>Uploaded: 2024-08-10</p>
                                                                <span>View Document</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className='col-lg-3'>
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <i className="bx bxs-file" />
                                                            <div>
                                                                <h5>First Aid Certificate</h5>
                                                                <p>Uploaded: 2024-08-10</p>
                                                                <span>View Document</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <i className="bx bxs-file" />
                                                            <div>
                                                                <h5>Background Check Certificate</h5>
                                                                <p>Uploaded: 2024-08-10</p>
                                                                <span>View Document</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className='col-lg-3'>
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <i className="bx bxs-file" />
                                                            <div>
                                                                <h5>National ID front and back</h5>
                                                                <p>Uploaded: 2025-01-10</p>
                                                                <span>View Document</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="modalmatchhistory" role="tabpanel">
                                    <div className="card personal_d">
                                        <div className="card-body">
                                            <h2>Match History</h2>
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <div>
                                                                <h5>Eagles FC vs Hawks United</h5>
                                                                <p>June 1, 2024</p>
                                                                <p>Central Stadium</p>
                                                                <span className="tagg">Completed</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <div>
                                                                <h5>Eagles FC vs Hawks United</h5>
                                                                <p>June 2, 2024</p>
                                                                <p>Central Stadium</p>
                                                                <span className="tagg">Completed</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <div>
                                                                <h5>Eagles FC vs Hawks United</h5>
                                                                <p>June 3, 2024</p>
                                                                <p>Central Stadium</p>
                                                                <span className="tagg">Completed</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <div>
                                                                <h5>Eagles FC vs Hawks United</h5>
                                                                <p>June 4, 2024</p>
                                                                <p>Central Stadium</p>
                                                                <span className="tagg">Completed</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <Link to>
                                                            <div>
                                                                <h5>Eagles FC vs Hawks United</h5>
                                                                <p>June 5, 2024</p>
                                                                <p>Central Stadium</p>
                                                                <span className="tagg">Completed</span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CoachDetail